import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PageHeader from '../components/PageHeader';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import canvas from '../constants/canvas';
import flowers from '../constants/flowers';
import wreaths from '../constants/wreaths';
import { SessionContext } from '../context/Session';

export default function ForSaleView() {
  let history = useHistory();
  const { setPurchaseItem } = React.useContext(SessionContext);
  const [loading, setLoading] = React.useState(false);
  const [shopForSale, setShowForSale] = React.useState([]);
  const [canvasSizeFilter, setCanvasSizeFilter] = React.useState('');
  const [canvasColorFilter, setCanvasColorFilter] = React.useState('');
  const [canvasTextureFilter, setCanvasTextureFilter] = React.useState('');
  const [canvasTopCoatFilter, setCanvasTopCoatFilter] = React.useState('');
  const [wreathSizeFilter, setWreathSizeFilter] = React.useState('');
  const [wreathColorFilter, setWreathColorFilter] = React.useState('');
  const [wreathThemeFilter, setWreathThemeFilter] = React.useState('');
  const [flowerSizeFilter, setFlowerSizeFilter] = React.useState('');
  const [flowerVaseColorFilter, setFlowerVaseColorFilter] = React.useState('');
  const [flowerFlowerColorFilter, setFlowerFlowerColorFilter] =
    React.useState('');
  const [typeValue, setTypeValue] = React.useState(
    history.location.state?.type
      ? history.location.state?.type.toLowerCase()
      : 'all'
  );
  const [images, setImages] = React.useState();
  const [filteredImages, setFilteredImages] = React.useState([]);

  React.useEffect(() => {
    setLoading(true);
    const images = importAll(require.context('../assets/images/for_sale'));
    setImages(images);
    getItemPhotos(images);
    getShopForSale();
    setLoading(false);
  }, []);

  React.useEffect(() => {
    setLoading(true);
    getFilteredForSale();
    setLoading(false);
  }, [
    canvasSizeFilter,
    canvasColorFilter,
    canvasTopCoatFilter,
    canvasTopCoatFilter,
  ]);

  function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
    });
    return images;
  }

  const getItemPhotos = (images) => {
    const filtered = Object.keys(images).filter((x) => {
      if (x.toLowerCase().includes('primary')) {
        return x;
      }
    });
    setFilteredImages(filtered);
  };
  const getShopForSale = () => {
    fetch(`https://sheline-art-website-api.herokuapp.com/shop/for-sale`)
      .then((res) => res.json())
      .then(
        (result) => {
          setShowForSale(result);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getFilteredForSale = () => {
    if (typeValue === 'canvas') {
      if (canvasSizeFilter) {
        return shopForSale.filter(
          (x) => x.type === 'canvas' && x.size === canvasSizeFilter
        );
      } else if (canvasColorFilter) {
        return shopForSale.filter(
          (x) => x.type === 'canvas' && x.color.includes(canvasColorFilter)
        );
      } else if (canvasTextureFilter) {
        return shopForSale.filter(
          (x) => x.type === 'canvas' && x.texture.includes(canvasTextureFilter)
        );
      } else if (canvasTopCoatFilter) {
        return shopForSale.filter(
          (x) => x.type === 'canvas' && x.top_coat.includes(canvasTopCoatFilter)
        );
      } else {
        return shopForSale.filter((x) => x.type === 'canvas');
      }
    } else if (typeValue === 'wreaths') {
      return shopForSale.filter((x) => x.type === 'wreath');
    }
    if (typeValue === 'flowers') {
      return shopForSale.filter((x) => x.type === 'flowers');
    } else {
      return shopForSale;
    }
  };

  const pageHeader = {
    title: `For Sale`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };

  return (
    <React.Fragment>
      <Container disableGutters maxWidth='2xl' component='main'>
        <PageHeader post={pageHeader} />
      </Container>
      <Container maxWidth='2xl' disableGutters>
        <Container sx={{ pb: 8 }} disableGutters>
          <Grid container spacing={1} direction='row'>
            <Grid item xs={12} md={2}>
              <Grid item>
                <Typography
                  gutterBottom
                  variant='primary'
                  sx={{ fontSize: 50 }}
                  align='center'
                >
                  Filters
                </Typography>
              </Grid>
              <Grid item>
                <FormControl component='fieldset'>
                  <FormLabel component='legend'>Type</FormLabel>
                  <RadioGroup
                    aria-label='gender'
                    name='radio-buttons-group'
                    value={typeValue}
                    onChange={(event) => setTypeValue(event.target.value)}
                  >
                    <FormControlLabel
                      value='all'
                      control={<Radio />}
                      label='All'
                    />
                    <FormControlLabel
                      value='canvas'
                      control={<Radio />}
                      label='Canvas'
                    />
                    <FormControlLabel
                      value='flowers'
                      control={<Radio />}
                      label='Flowers'
                    />
                    <FormControlLabel
                      value='wreaths'
                      control={<Radio />}
                      label='Wreaths'
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {typeValue === 'canvas' && (
                <React.Fragment>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Size
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={canvasSizeFilter}
                        label='Size'
                        onChange={(event) =>
                          setCanvasSizeFilter(event.target.value)
                        }
                      >
                        {canvas.sizes.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Color
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={canvasColorFilter}
                        label='Color'
                        onChange={(event) =>
                          setCanvasColorFilter(event.target.value)
                        }
                      >
                        {canvas.colors.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Texture
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={canvasTextureFilter}
                        label='Texture'
                        onChange={(event) =>
                          setCanvasTextureFilter(event.target.value)
                        }
                      >
                        {canvas.textures.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Top Coat
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={canvasTopCoatFilter}
                        label='Top Coat'
                        onChange={(event) =>
                          setCanvasTopCoatFilter(event.target.value)
                        }
                      >
                        {canvas.topCoats.map((topCoat) => (
                          <MenuItem value={topCoat} key={topCoat}>
                            {topCoat.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </React.Fragment>
              )}
              {typeValue === 'wreaths' && (
                <React.Fragment>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Size
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={wreathSizeFilter}
                        label='Size'
                        onChange={(event) =>
                          setWreathSizeFilter(event.target.value)
                        }
                      >
                        {wreaths.sizes.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size}"
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Color
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={wreathColorFilter}
                        label='Color'
                        onChange={(event) =>
                          setWreathColorFilter(event.target.value)
                        }
                      >
                        {wreaths.colors.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Theme
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={wreathThemeFilter}
                        label='Theme'
                        onChange={(event) =>
                          setWreathThemeFilter(event.target.value)
                        }
                      >
                        {wreaths.themes.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </React.Fragment>
              )}
              {typeValue === 'flowers' && (
                <React.Fragment>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Size
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={wreathSizeFilter}
                        label='Size'
                        onChange={(event) =>
                          setFlowerSizeFilter(event.target.value)
                        }
                      >
                        {flowers.sizes.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Vase Color
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={flowerVaseColorFilter}
                        label='Vase Color'
                        onChange={(event) =>
                          setFlowerVaseColorFilter(event.target.value)
                        }
                      >
                        {flowers.vase_colors.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl sx={{ mb: 1 }} fullWidth>
                      <InputLabel id='demo-simple-select-label'>
                        Flower Color
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={flowerFlowerColorFilter}
                        label='Flower Color'
                        onChange={(event) =>
                          setFlowerFlowerColorFilter(event.target.value)
                        }
                      >
                        {flowers.flower_colors.map((size) => (
                          <MenuItem value={size} key={size}>
                            {size.toUpperCase()}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} md={10}>
              <Grid container spacing={1}>
                {!loading &&
                  getFilteredForSale().map((item) => {
                    const pic = filteredImages.filter((x) => {
                      if (x.toLowerCase().includes(item.pic_name.toLowerCase()))
                        return x;
                    });
                    return (
                      <Grid item key={item.id} xs={12} sm={6} md={3}>
                        <Card
                          sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                          }}
                        >
                          <CardMedia
                            component='img'
                            image={images[pic] && images[pic].default}
                            alt={pic}
                          />
                          <CardContent>
                            <Typography
                              gutterBottom
                              variant='primary'
                              component='h2'
                              align='center'
                            >
                              {item.name}
                            </Typography>
                            <Typography
                              gutterBottom
                              variant='primary'
                              component='h2'
                              align='center'
                            >
                              ${item.price}
                            </Typography>
                          </CardContent>
                          <CardActions style={{ justifyContent: 'center' }}>
                            <Button
                              size='small'
                              variant='contained'
                              onClick={() => {
                                setPurchaseItem(item);
                                return history.push(`/for-sale-item`, {
                                  item,
                                });
                              }}
                            >
                              View Item
                            </Button>
                          </CardActions>
                        </Card>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </React.Fragment>
  );
}
